<template>
  <home />
</template>

<script>
import Home from "./components/Home.vue";

export default {
  name: "App",
  components: {
    Home,
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
body {
  background: #e5e5e5;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #383838;
  font-size: 62.5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#app {
  max-width: 640px;
  margin: 0 auto;
  padding: 30px;
}

@media (max-width: 540px) {
  body {
    display: block;
  }
  #app {
    font-size: 0.8em;
    padding: 15px;
  }
}
</style>
